module.exports = __webpack_public_path__ + "img/undraw_art_muse.81d5871a.png";